// extracted by mini-css-extract-plugin
export default {"titleQuantityFalsification":"ActRejection_titleQuantityFalsification__8JQn7","datePeriodFilter":"ActRejection_datePeriodFilter__W5EkW"};